import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

/** The empty slot at the end of the My Genies grid — a placeholder for the next genie. */
const UnlockGenieCard = () => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate("/user-hub/genie-setup")}
      className={cn(
        "group w-full h-full min-h-[360px] rounded-3xl border-2 border-dashed border-gray-200 bg-white/60",
        "flex flex-col items-center justify-center gap-4 p-8 text-center",
        "transition-all duration-200 hover:border-genie-primary hover:bg-white hover:shadow-[0_8px_32px_rgba(78,156,255,0.1)]",
      )}
    >
      <span className="w-16 h-16 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 transition-colors group-hover:border-genie-primary group-hover:text-genie-primary">
        <Plus className="w-7 h-7" />
      </span>
      <span className="text-xl font-semibold text-gray-400 transition-colors group-hover:text-gray-700">
        Unlock your next genie
      </span>
    </button>
  );
};

export default UnlockGenieCard;
